import logo from '../../assets/images/logo.png'

const Logo = () => {
  return <img width={256} src={logo} alt="Skaderapportering" />
}

export { Logo }
